import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Observable, filter, take } from 'rxjs';
import {
  CellClickedEvent,
  ColDef,
  GridReadyEvent,
  SideBarDef,
} from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { ShipmentService } from 'src/app/services/modules/shipments/shipment.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { InfoDialogComponent } from 'src/app/components/info-dialog/info-dialog.component';
import { SavedSearchComponent } from 'src/app/components/saved-search/saved-search.component';

interface Status {
  id: number;
  name: string;
  value: string;
}

@Component({
  selector: 'app-shipment-bookings',
  templateUrl: './shipment-bookings.component.html',
  styleUrls: ['./shipment-bookings.component.scss'],
  providers: [ConfirmDialogComponent],
})
export class ShipmentBookingsComponent implements OnInit {
  public selectedStatus: string[] = [];
  public statuses!: any[];

  public gridApi: any;
  public viewFilterType: string = 'booking';
  public module: string = 'shipment';

  public skipEventHandler: boolean = false;
  public fromDashboard: boolean = false;

  @ViewChild('savedSearch') savedSearch!: SavedSearchComponent;

  public columnDefs: ColDef[] = [];

  // DefaultColDef sets props common to all Columns
  public defaultColDef: ColDef = {
    // flex: 1,
    width: 130,
    filter: true,
    sortable: true,
    floatingFilter: true,
    // // lockPinned: true,
    resizable: true,
  };
  public sideBar: SideBarDef | string | string[] | boolean | null = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      },
    ],
    defaultToolPanel: 'filters',
    hiddenByDefault: true,
  };

  public cacheBlockSize = 10;
  public maxBlocksInCache = 10;
  public rowData!: any[];

  public customerDetails: any;
  public customerId: any = null;

  private gridColumnApi: any;

  public paginationPageSize = 20;
  public paginationPageSizeSelector: number[] | boolean = [10, 20, 50, 100];

  constructor(
    private shipmentService: ShipmentService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private _modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private confirmDialogModal: ConfirmDialogComponent,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.authService.user$
      .pipe(
        filter((user) => !!user),
        take(1),
      )
      .subscribe((user: any) => {
        this.customerId = user.customer_id;
        this.customerDetails = user;
      });

    this.selectAllForDropdownItems(this.getStatus());
    // this.setSelectedStatus = this.statuses[0]['id'];
    // this.getBookings();

    this.checkFromDashboard();
  }

  private checkFromDashboard() {
    this.route.queryParams.subscribe((params) => {
      console.log("params['filter']", params['filter']);

      if (params['filter'] !== undefined) {
        this.fromDashboard = true;

        // clearFilter uses gridApi; only call it after grid is ready
        if (this.gridApi) {
          this.clearFilter();
        }

        const filter = String(params['filter']).toLowerCase();
        if (filter === 'complete') {
          this.initComplete();
        } else if (filter === 'in-transit') {
          this.initInTransit();
        } else if (filter === 'booked') {
          this.initBooked();
        }

        this.clearUrlParams();

        if (this.savedSearch) this.savedSearch.fetchViewFilterList(true);
      }
    });
  }

  private initComplete() {
    console.log('###initComplete');

    this.selectedStatus = ['complete'];

    const queryString = 'status_array[]=complete';

    this.fetchDataRow(queryString).subscribe((res: any) => {
      let idSequence = 0;
      res.data.data.forEach((item: any) => {
        item.id = idSequence++;
      });
      this.rowData = res.data.data;
      this.columnDefs = this.shipmentService.transformBookingColumn(
        res.data.columns,
      );
    });

    this.fromDashboard = true;

    // this.onSelectionChange();
  }

  private initInTransit() {
    console.log('###initInTransit');

    this.selectedStatus = [
      'in_transit',
      'customer_collected',
      'provider_collected',
    ];

    const queryString =
      'status_array[]=customer_collected&status_array[]=in_transit&status_array[]=provider_collected';

    this.fetchDataRow(queryString).subscribe((res: any) => {
      let idSequence = 0;
      res.data.data.forEach((item: any) => {
        item.id = idSequence++;
      });
      this.rowData = res.data.data;
      this.columnDefs = this.shipmentService.transformBookingColumn(
        res.data.columns,
      );
    });

    this.fromDashboard = true;

    // this.onSelectionChange();
  }

  private initBooked() {
    console.log('###initBooked');

    this.selectedStatus = ['booked'];

    const queryString = 'status_array[]=booked';

    this.fetchDataRow(queryString).subscribe((res: any) => {
      let idSequence = 0;
      res.data.data.forEach((item: any) => {
        item.id = idSequence++;
      });
      this.rowData = res.data.data;
      this.columnDefs = this.shipmentService.transformBookingColumn(
        res.data.columns,
      );
    });

    this.fromDashboard = true;
  }

  clearUrlParams() {
    console.log('###clearUrlParams');
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: {} });
  }

  applyStatusFilter(filterValue: string) {
    console.log('applyStatusFilter', filterValue);
    setTimeout(() => {
      const statuses = this.statuses.filter(
        (s) => s.name.toLowerCase() === filterValue,
      );
      console.log(
        'statuses',
        statuses.map((s) => s.name),
      );

      if (statuses.length > 0) {
        this.selectedStatus = statuses.map((status) => status.value);
      } else {
        this.selectedStatus = [];
      }
      this.onSelectionChange();
    });
  }

  fetchDataRow(queryString: string = '') {
    console.log('###fetchDataRow', queryString);

    return this.shipmentService.getCustomerBooking(queryString).pipe(take(1));
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    if (!this.fromDashboard) {
      console.log('###onGridReady');

      let queryString = '';
      let pickedStatus: string[] = [];
      pickedStatus = ['All'];

      if (this.fromDashboard) {
        pickedStatus = this.selectedStatus;
        this.fromDashboard = false;
      }

      for (let i = 0; i < pickedStatus.length; i++) {
        queryString += `status_array[]=${encodeURIComponent(pickedStatus[i])}&`;
      }
      queryString = queryString.slice(0, -1);

      this.fetchDataRow(queryString).subscribe((res: any) => {
        let idSequence = 0;
        res.data.data.forEach((item: any) => {
          item.id = idSequence++;
        });
        this.rowData = res.data.data;
        if (this.savedSearch) this.savedSearch.refresh(this.gridApi);
        // this.fetchColumnStateViewFilter();
        this.columnDefs = this.shipmentService.transformBookingColumn(
          res.data.columns,
        );
      });

      this.setSideBarVisible(true);
    } else {
      this.fromDashboard = false;
    }
  }

  setSideBarVisible(value: boolean) {
    this.gridApi.setSideBarVisible(value);
  }

  statusLabelName(v: any) {
    if (v.name) return v.name;
    if (v.value) return v.value;
    return 'All Statuses';
  }

  getStatus() {
    console.log('###getStatus');
    let status: any = this.shipmentService
      .fetchStatus(this.viewFilterType)
      .pipe(take(1))
      .subscribe((res: any) => {
        this.statuses = res.data;
        console.log('INSIDE ###getStatus - this.statuses', this.statuses);
        this.checkFromDashboard();
      });
    console.log('###getStatus - this.statuses', this.statuses);
    return this.statuses;
  }

  // Setter
  set setSelectedStatus(v: any) {
    this.selectedStatus = v;
  }

  selectAllForDropdownItems(items: any[]) {
    console.log('###selectAllForDropdownItems');
    if (items) {
      let allSelect = (items: any[]) => {
        items.forEach((element: { [x: string]: string }) => {
          element['selectedAllGroup'] = 'All Statuses';
        });
      };
      allSelect(items);
    }
  }

  clearFilter() {
    if (this.savedSearch) this.savedSearch.clearFilter();
  }

  clearFiltersExternally() {
    this.selectedStatus = [];
  }

  onColumnVisible(event: any) {
    if (this.savedSearch) this.savedSearch.saveColumnState();
  }

  eventHandlingListener(event: any) {
    if (this.savedSearch) {
      this.savedSearch.handleGridEvent(event);
    }
  }
  onSelectionChange() {
    console.log('onSelectionChange');
    let pickedStatus: string[] = [];
    let isSelectedAll: boolean = this.selectedStatus.includes('All Statuses');

    if (this.statuses.length === this.selectedStatus.length || isSelectedAll) {
      this.setSelectedStatus = [{ selectedAllGroup: 'All Statuses' }];
      this.statuses.forEach((e, index) => {
        pickedStatus[index] = e.value;
      });
    } else {
      console.log('this.selectedStatus.', this.selectedStatus);
      if (this.selectedStatus.length == 0) {
        pickedStatus = ['All'];
        // this.statuses.forEach((e, index) => {
        //   pickedStatus[index] = e.value
        // })
      } else {
        console.log('else else');
        pickedStatus = this.selectedStatus;
      }
    }

    let queryString = '';
    // this.gridApi.showLoadingOverlay();

    for (let i = 0; i < pickedStatus.length; i++) {
      queryString += `status_array[]=${encodeURIComponent(pickedStatus[i])}&`;
    }
    queryString = queryString.slice(0, -1);

    this.fetchDataRow(queryString).subscribe((res: any) => {
      let idSequence = 0;
      res.data.data.forEach((item: any) => {
        item.id = idSequence++;
      });
      this.rowData = res.data.data;
      this.columnDefs = this.shipmentService.transformBookingColumn(
        res.data.columns,
      );
    });
  }

  compareAccounts = (item: any, selected: any) => {
    if (selected.selectedAllGroup && item.selectedAllGroup) {
      return item.selectedAllGroup === selected.selectedAllGroup;
    }
    return false;
  };

  getCustomerDetails() {
    this.authService.user$
      .pipe(
        filter((user) => !!user),
        take(1),
      )
      .subscribe((user: any) => {
        this.customerDetails = user;
      });
  }
}
